import ChainLogo from './ChainLogo';

export default ChainLogo;
